const _excluded = ["className", "buttonClassname", "textfieldClassname", "value", "onClick", "onError", "onCopy", "buttonLabel", "testId", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useRef, useState } from 'react';
import cn from 'classnames';
import { Button, TextField } from 'seagull';
import { Checkmark, CopyLiner24 } from 'seagull/icons';
import { useIoContext } from "../../contexts";
import styles from "./CopyToClipboard.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function CopyToClipboard(props) {
  const {
      className,
      buttonClassname,
      textfieldClassname,
      value,
      onClick: _onClick,
      onError,
      onCopy,
      buttonLabel,
      testId,
      size
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const resolvedTestId = testId || 'copy-to-clipboard';
  const {
    copyToClipboard
  } = useIoContext();
  const inputRef = useRef();
  const [isCopied, setIsCopied] = useState(false);
  const [hasError, setHasError] = useState(false);
  const ButtonWrapper = _ref => {
    let {
      children
    } = _ref;
    return buttonClassname ? /*#__PURE__*/_jsx("div", {
      className: buttonClassname,
      children: children
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  };
  const TextfieldWrapper = _ref2 => {
    let {
      children
    } = _ref2;
    return textfieldClassname ? /*#__PURE__*/_jsx("div", {
      className: textfieldClassname,
      children: children
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, className),
    "data-testid": resolvedTestId,
    children: [/*#__PURE__*/_jsx(TextfieldWrapper, {
      children: /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
        collapseHelperText: false,
        size: size,
        inputProps: {
          readOnly: true
        },
        value: value,
        inputRef: inputRef,
        onClick: () => {
          var _inputRef$current;
          return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.select();
        },
        onCopy: onCopy,
        className: styles.input,
        helperText: hasError ? 'Copy failed. Please try manually or give it another shot later.' : undefined,
        error: hasError
      }, rest), {}, {
        testId: "".concat(resolvedTestId, "-input")
      }))
    }), /*#__PURE__*/_jsx(ButtonWrapper, {
      children: /*#__PURE__*/_jsx(Button, {
        testId: "".concat(resolvedTestId, "-button"),
        prefixIcon: isCopied ? /*#__PURE__*/_jsx(Checkmark, {}) : /*#__PURE__*/_jsx(CopyLiner24, {}),
        onClick: () => {
          try {
            if (_onClick) _onClick();
            if (!value) return;
            copyToClipboard(value);
            setIsCopied(true);
            onCopy && onCopy();
            setTimeout(() => setIsCopied(false), 2000);
          } catch (e) {
            setHasError(true);
            setTimeout(() => setHasError(false), 2000);
            if (onError) onError();
          }
        },
        loading: !value,
        disabled: isCopied,
        className: styles.button,
        children: isCopied ? 'Copied' : buttonLabel || 'Copy link'
      })
    })]
  });
}